import axios from "axios";
import Cookie from "js-cookie";
import appUrls from '../../helpers/environment';

import { removeProperties } from '../utilities';


async function checkUser () {
    try {    
        const user_check = await axios.get(`${appUrls.api}/api/user_check`, {
            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
        })

        let authUser = {}

        if ( user_check.data.outcome ) {
            authUser = user_check.data.user_data
        } else {
            console.log(user_check.data.message)
        }

        return authUser
    } catch ( error ) {
        console.log(error);
        return false
    }
}


function prepProjectData( data ) {
    try {
        const projectProperties = ['user_id', 'project_id', 'steps_completed', 'status', 'project_title']
        const modinfoProperties = ['module_name', 'module_key', 'steps_to_complete']
        const teamProperties    = ['teamemail']

        const prj_data = removeProperties(data.prj, projectProperties);
        const mod_data = removeProperties(data.prj.modinfo, modinfoProperties);
        const srg_data = removeProperties(data.prj.modinfo.srg_team, teamProperties);

        const project_data = { ...prj_data, ...mod_data, ...srg_data }

        const progressProperties = ['completed_val', 'stage_name', 'id', 'is_independent']
        const progress_data = removeProperties(data.step, progressProperties);

        return [project_data, progress_data];

    } catch (error) {
        console.log(error);
        return false
    }
}

function setStatusData ( status, all_status_data ) {
    try {
        let statusData = { 
            status: status,
            status_internal_label: '',
            status_external_label: '',
            status_color: '',
            status_progress_color: '',
            status_text_color: ''
        }

        all_status_data.find( s => {
            if ( s.value === status ) {
                statusData.status                   = s.value
                statusData.status_internal_label    = s.internal_label
                statusData.status_external_label    = s.external_label
                statusData.status_color             = s.status_color
                statusData.status_progress_color    = s.status_progress_color
                statusData.status_text_color        = s.status_text_color
            }
        })
    
        return statusData
    } catch ( error ) {
        console.warn(`Error in setStatusData: ${error.message}`);
        return error
    }
}

async function getModuleDataByKey ( module_key ) {
    try {
        const module_rs = await axios.get(`${appUrls.api}/api/module_info/${module_key}`, {
            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
        })

        const module_info = module_rs.data.outcome && module_rs.data.info ? module_rs.data.info : {}
        
        return module_info
    } catch ( err ) {
        console.log(err)
        return false
    }
}

export {
    checkUser,
    prepProjectData,
    setStatusData,
    getModuleDataByKey
};


// WEBPACK FOOTER //
// ./src/components/shared/projectFunctions.js